import React from "react";
import { createPortal } from "react-dom";
import styles from "./BottomModal.module.scss";
import { useBottomModal } from "./useBottomModal";

interface BottomModalProps {
  isVisible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function BottomModal({
  isVisible,
  onClose,
  children,
}: BottomModalProps) {
  const { handleBackdropClick } = useBottomModal(isVisible, onClose);

  if (!isVisible) return null;

  return createPortal(
    <div className={styles.overlay} onClick={handleBackdropClick}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>,
    document.body,
  );
}